<template>
  <div
    class="success"
    :class="{active:active}"
  >O anfitrião já foi notificado da sua presença na recepção. Por favor espere um momento.</div>
</template>
<script>
export default {
  name: "success",
  data() {
    return {
      active: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      let sidePanelText = document.querySelector(".iden__sidepanel-text");
      sidePanelText.innerHTML = "All ready.";

      this.hideElement(".app__back-btn");
      this.restart();
    });
  },
  methods: {
    NotificarSetor() {},
    restart: function() {
      setTimeout(() => {
        this.active = true;
      }, 100);

      setTimeout(() => {
        this.$router.push({ path: "home" });
      }, 6000);
    }
  }
};
</script>
